import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { basicHeaders } from '../utils';

interface SimulatorRuntime {
  cycleCurrentMinute: number;
  cycleStartTime: string;
  previousPayload: PreviousPayload;
}

interface PreviousPayload {
  auto: boolean;
  custom: any;
}

export const simulatorApi = createApi({
  reducerPath: 'simulatorApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_STREAMING_SERVICE}`,

    /* prepareHeaders: basicHeaders, */
  }),
  tagTypes: ['simulatorRuntime'],
  endpoints: (builder) => ({
    // prettier-ignore
    getSimulatorRuntimeByDeviceId: builder.query<SimulatorRuntime,string>({
      query: (id) => ({
        url: "/simulator/runtime/" + id,
      }),
      providesTags: ['simulatorRuntime'],
    }),
    updateSimulatorMinuteRuntime: builder.mutation<
      SimulatorRuntime,
      { deviceId: string; minute: number }
    >({
      query: (body) => ({
        url: '/simulator/runtime/',
        method: 'post',
        body,
      }),
      invalidatesTags: ['simulatorRuntime'],
    }),
  }),
});

export const { useGetSimulatorRuntimeByDeviceIdQuery, useUpdateSimulatorMinuteRuntimeMutation } =
  simulatorApi;
